const REFERENCE_TYPE_ALIASES = {
  bol: new Set(['bol', 'bol #']),
  po: new Set(['po', 'po #']),
};

const normalizeText = (value) => (typeof value === 'string' ? value.trim() : '');

const normalizeReferenceType = (value) => normalizeText(value).toLowerCase().replace(/\s+/g, ' ');

export const getStructuredReferences = (load) => {
  if (!Array.isArray(load?.references)) return [];

  return load.references
    .filter((reference) => reference && typeof reference === 'object')
    .map((reference) => ({
      ...reference,
      type: normalizeText(reference.type),
      value: normalizeText(reference.value),
      ...(normalizeText(reference.label) ? { label: normalizeText(reference.label) } : {}),
    }))
    .filter(({ type, value }) => type && value);
};

export const isReferenceType = (reference, type) => {
  const aliases = REFERENCE_TYPE_ALIASES[type];
  return Boolean(aliases?.has(normalizeReferenceType(reference?.type)));
};

export const getReferenceValue = (load, type) => {
  if (!REFERENCE_TYPE_ALIASES[type]) return null;

  const dedicatedValue = normalizeText(load?.[`${type}_number`]);
  if (dedicatedValue) return dedicatedValue;

  return getStructuredReferences(load).find((reference) => isReferenceType(reference, type))?.value || null;
};

export const getAdditionalReferences = (load) => (
  getStructuredReferences(load).filter(
    (reference) => !isReferenceType(reference, 'bol') && !isReferenceType(reference, 'po')
  )
);
